(ns frontend.view.settings2.permissions.sub
  (:require
   [clojure.set :as set]
   [clojure.string :as string]
   [common.localization :as loc]
   [common.schema.field-type :as field-type]
   [common.schema.registry :as registry]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.view.settings2.permissions.field-settings.events :as field-settings-events]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::selected-entity-type
 (fn [db]
   (get-in db [::selected-entity-type])))

(rf/reg-sub
 ::create-dialog-visible?
 (fn [db]
   (get-in db [::create-dialog-visible?])))

(rf/reg-sub
 ::create-dialog-status
 (fn [db]
   (get-in db [::create-dialog-status])))

(rf/reg-sub
 ::new-field
 (fn [db]
   (get-in db [::new-field])))

(rf/reg-sub
 ::similar-fields
 (fn [db]
   (when-let [new-field (get-in db [::new-field])]
     (time (let [ft (:field/field-type new-field)
                 entity-type (get-in db [::selected-entity-type])
                 tenant @session/tenant
                 tenant-field-configurations (:tenant/field-configurations tenant)
                 tenant-schema @session/tenant-schema
                 blacklisted (set (:tenant/blacklisted-fields tenant))
                 whitelisted (set (:tenant/whitelisted-custom-fields tenant))

                 ;; blaclisted + not-in-use-blocked - whitelisted - in-use-disabled - mandatory
                 fields-hidden-from-TA
                 (->> blacklisted
                      (set)
                      (set/union (->> (registry/get-schema tenant-schema entity-type)
                                      (filter (fn [[attr fs]]
                                                (= :not-in-use-blocked
                                                   (->> fs
                                                        :field/default-visibility
                                                        :field-visibility))))
                                      (map first)
                                      (set)))
                      (cu/flip set/difference whitelisted)
                      (cu/flip set/difference
                               (->> (registry/get-schema tenant-schema entity-type)
                                    (filter (fn [[attr fs]]
                                              (= :in-use-disabled
                                                 (->> fs
                                                      :field/default-visibility
                                                      :field-visibility))))
                                    (map first)
                                    (set))))
                 lc-case-name (cu/str-trim-lcase (:field/name new-field))
                 name-filter (when-not (cu/blank-value? lc-case-name)
                               lc-case-name)
                 entity-schema (registry/get-schema tenant-schema entity-type)]
             (->> entity-schema
                  (filter (fn [[k fs]]
                            (= (:field/data-type fs)
                               (->> field-type/field-types
                                    ft
                                    :data-type))))
                  (remove (fn [[k fs]]
                            (when name-filter
                              (not (string/includes? (string/lower-case (loc/field-name k fs))
                                                     name-filter)))))
                  (remove (fn [[k fs]]
                            (let [fv (get-in fs [:field/default-visibility :field-visibility])
                                  whitelisted?
                                  (some #{k} (:tenant/whitelisted-custom-fields tenant))
                                  hide? (and (= :not-in-use-blocked fv)
                                             (not whitelisted?))]
                              hide?)))
                  (remove (fn [[attribute fs]]
                            (field-settings-events/hide-field?
                             {:tenant         tenant
                              :entity-schema  entity-schema
                              :tenant-field-configurations tenant-field-configurations
                              :entity-type    entity-type
                              :show-inactive? true
                              :fields-hidden-from-TA fields-hidden-from-TA}
                             [attribute fs])))))))))
